import type {
  ITransferPopupSelection,
  IUploadProgressEntry,
} from "@frontend-shared/types";

// NOTE: NSAI-7067 — DOCKED sits in the page flow directly above a chat
// composer; FLOATING hovers in the bottom corner of the content area wherever
// no composer is mounted.
export enum ETransferPopupVariant {
  DOCKED = "docked",
  FLOATING = "floating",
}

export interface ITransferPopupProps {
  variant: ETransferPopupVariant;
}

export interface ITransferPopupCardProps {
  variant: ETransferPopupVariant;
  primary: IUploadProgressEntry;
  selection: ITransferPopupSelection;
  now: number;
  onOpenUploads: () => void;
  onClose: () => void;
}

export interface ITransferPopupStatusIconProps {
  primary: IUploadProgressEntry;
  isMultiple: boolean;
}

export interface ITransferPopupProgressProps {
  primary: IUploadProgressEntry;
  selection: ITransferPopupSelection;
  isMultiple: boolean;
  // NOTE: The id of the card's title, which names the progress bar.
  labelledById: string;
}

export interface IUseTransferPopupCopyProps {
  primary: IUploadProgressEntry;
  selection: ITransferPopupSelection;
  now: number;
}

export interface ITransferPopupCopy {
  title: string;
  subtitle: string | null;
  closeAriaLabel: string;
  // NOTE: True when the close button aborts a transfer rather than merely
  // hiding the card — the button reads as destructive only then.
  isCloseCancelling: boolean;
}

export interface IFloatingTransferPopupProps {
  // NOTE: Lifts the card clear of a page that ends in its own bottom bar (the
  // meeting page's playback controls).
  isRaised: boolean;
}
